<div class="faq">
    <h3 class="section-title text-center">{{ 'menu.modals.needHelp.faq.content.title' | translate }}</h3>
    <app-searchbar (searchEvent)="onSearch($event)"></app-searchbar>
    <div class="faq__questions">
        <p-accordion [value]="0">
            @for (question of faq; track question; let i = $index) {
                <p-accordion-panel [value]="i">
                    <p-accordion-header>{{ question.name | translate }}</p-accordion-header>
                    <p-accordion-content>
                        <p>{{ question.answer | translate }}</p>
                    </p-accordion-content>
                </p-accordion-panel>
            }
        </p-accordion>
    </div>
    <div class="faq__cantfind">
        <span>{{ 'menu.modals.needHelp.faq.content.cantfind' | translate }}</span>
        <p-button
            [link]="true"
            [label]="'menu.modals.needHelp.faq.content.askHere' | translate"
            (onClick)="onClickCantFindQuestion()" />
    </div>
</div>
